<div class="activity-navigation">
	<div class="task-view-container">
		<div class="navigation-header">
			<h4>{{ 'activity-view_pill-overview' | translate }}</h4>
		</div>
		<div class="navigation-list-container">
			@for (navigationItem of navigationItems; track navigationItem.name; let i = $index) {
				<a
					class="task-item"
					[class.active]="isActiveRoute(navigationItem)"
					(click)="onNavigationClick(navigationItem)"
					(keyup.enter)="onNavigationClick(navigationItem)"
					(keyup.space)="onNavigationClick(navigationItem)"
					tabindex="0"
					role="button"
					[attr.aria-label]="navigationItem.translationKey | translate">
					<div class="navigation-item-name">{{ navigationItem.translationKey | translate }}</div>
				</a>
			}
		</div>
	</div>
</div>
